var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIconMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 201,
    viewBox: "0 0 184 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.566 151.302C74.2982 143.898 58.9669 134.571 45.4106 127.174L44.7332 103.947L0.839924 128.193C-0.344411 158.148 -6.38077 148.463 44.3131 177.485C103.652 211.456 73.5897 210.76 162.004 161.289C179.524 151.487 177.945 157.72 177.89 125.385L177.819 101.789C154.286 112.659 102.493 147.04 88.5645 151.304L88.566 151.302Z",
    fill: "#003399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.376427 50.5027L0.195068 96.7557L132.18 22.5472L88.4823 1.29101e-05L0.376427 50.5027Z",
    fill: "#6699FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.795 87.7867L68.3145 114.032L89.3845 123.692L177.853 74.7056L183.474 48.1826L155.447 39.6334L68.795 87.7867Z",
    fill: "#ED6E0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconMain);
export default __webpack_public_path__ + "static/media/logo_icon_main.d30aee27c0fcf2146b0cbd97878f1a3d.svg";
export { ForwardRef as ReactComponent };